
import AllAssessmentsAudits from '../features/admin/components/Assessments/AllAssessmentsAudits'

function AssessmentAudits() {
  return (
    <><AllAssessmentsAudits/></>
  )
}

export default AssessmentAudits